<script>
export default {
  props: {
    bank: {
      required: true
    },
    baseRoute: {
      type: String,
      default: 'hyperion.finances.bank'
    }
  },
  computed: {
    ready() {
      return ! this.loading.dataset && ! this.loading.item
    },
    creating() {
      return this.bank === null
    },
    updateUrl() {
      return this.routeUri(this.baseRoute + '.update', { bank_hash: this.bank.hash })
    },
    createUrl() {
      return this.routeUri(this.baseRoute + '.store')
    }
  },
  data: () => ({
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
    loading: {
      dataset: false,
      item: false,
      submit: false
    },
    rules: {
      bank_name: [
        { required: true, message: "Bank is required", trigger: 'blur' },
      ],
      branch_name: [
        { required: true, message: "Branch name is required", trigger: 'blur' },
      ],
      account_holder: [
        { required: true, message: "Account holder is required", trigger: 'blur' },
      ],
      account_number: [
        { required: true, message: "Destination Account number is required", trigger: 'blur' },
      ]
    },
    item: {
      bank_name: '',
      bank_code: '',
      bank_swift: '',
      account_number: '',
      account_holder: '',
      branch_name: '',
    },
    dataset: {
      banks: []
    }
  }),
  created() {
    this.getDataSet()

    if (this.bank instanceof Object)
      this.item = this.bank

    if (this.bank instanceof String)
      this.getItem()
  },
  methods: {
    autocomplete(v) {
      if (v.length === 0) {
        this.item.biller = ""
      } else {
        this.item.biller = _.map(v, (o) => o.id)[0]
      }
    },
    getDataSet() {
      this.loading.dataset = true
      this.$http.get(this.createUrl + '/dataset')
        .then((r) => this.dataset = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading.dataset = false)
    },
    getItem() {
      this.loading.item = true
      this.$http.get(this.updateUrl)
        .then((r) =>this.item = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading.item = false)
    },
    bankSelected(bank_name) {
      let bank = this.dataset.banks.find(item => item.name === bank_name)

      this.item.bank_code = bank.code
    },
    bankFilters(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    reload() {
      this.$emit('success')
      this.$notification.success({
        message: "Success",
        description: "Data has been successfully saved!",
        onClose: () => window.location.reload()
      });
    },
    update() {
      this.$http.put(this.updateUrl, this.item)
        .then(() => this.reload())
        .then((e) => this.handleXhrError(e))
    },
    create() {
      this.$http.post(this.createUrl, this.item)
        .then(() => this.reload())
        .catch((e) => this.handleXhrError(e))
    },
    submit() {
      this.$refs.bankForm.validate(valid => {
        if (valid) {
          this.loading.submit = true
          this.creating ? this.create() : this.update()
        } else {
          return false;
        }
      })
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-skeleton :loading="! ready">
      <a-form-model :labelCol="labelCol" :wrapperCol="wrapperCol" :model="item" :rules="rules" ref="bankForm">
        <a-divider dashed orientation="left"> Bank Information</a-divider>

        <a-form-model-item label="Bank" prop="bank_name">
          <a-select show-search placeholder="Select bank" v-model="item.bank_name" @change="bankSelected" option-filter-prop="children" :filter-options="bankFilters">
            <a-icon slot="prefix" type="bank" />
            <a-select-option v-for="(bank,index) in dataset.banks" :value="bank.name" :key="`bank-${bank.code}`">{{ bank.name }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="Swift Code" prop="swift_code" v-model="item.bank_swift">
          <a-input v-model="item.bank_swift" placeholder="Swift Code">
            <a-icon slot="prefix" type="safety-certificate" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item label="Branch" prop="branch_name" v-model="item.branch_name">
          <a-input v-model="item.branch_name" placeholder="Branch name">
            <a-icon slot="prefix" type="global" />
          </a-input>
        </a-form-model-item>

        <a-divider dashed orientation="left"> Account Information</a-divider>

        <a-form-model-item label="Account Holder" prop="account_holder" v-model="item.account_holder">
          <a-input v-model="item.account_holder" placeholder="Account holder">
            <a-icon slot="prefix" type="contacts" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item label="Account Number" prop="account_number" v-model="item.account_number">
          <a-input v-model="item.account_number" placeholder="Account number">
            <a-icon slot="prefix" type="number" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item :wrapperCol="{ span: this.wrapperCol.span, offset: this.labelCol.span }">
          <a-button :loading="loading.submit" type="primary" @click="submit" icon="save">Save</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-skeleton>
  </a-card>
</template>
